import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectDialogState } from '../../../../dialog/features/dialog.selectors';
import { DialogService } from '../../../../dialog/services/dialog.service';
import { CommonModule } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';

@Component({
  standalone:true,
  imports:[CommonModule,ClipboardModule],
  selector: 'app-stream-help',
  templateUrl: './stream-help.component.html',
  styleUrls: ['./stream-help.component.scss']
})
export class StreamHelpComponent implements OnInit, OnDestroy {
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  constructor(
    private store: Store,
    private dialogService: DialogService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  onCopyToClipboard(event, id, text = 'Copy') {
    event.preventDefault();

    const button = document.getElementById(id);

    button.innerHTML = '<i class="far fa-copy mr-2"></i> Copied!';
    button.style.color = '#37373c';
    button.style.backgroundColor = '#dddddd';
    setTimeout(() => {
      this.ngZone.run(() => {
        button.innerHTML = `<i class="far fa-copy mr-2"></i> ${text}`;
        button.style.color = '#37373c';
        button.style.backgroundColor = '#fefefe';
      });
    }, 1200);
  }

  getText(text) {
    return text;
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);
  }
}
